import React from 'react';

const TublyLogo: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 100 70"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Tubly Logo"
  >
    <rect x="5" y="12.5" width="90" height="45" rx="12" fill="#FF3333" />
    <path d="M44 28 L 60 35 L 44 42 Z" fill="white" />
    <g stroke="white" strokeWidth="2.5" fill="none" strokeLinecap="round" opacity="0.65">
      <path d="M65 29 q 4 6, 0 12" />
      <path d="M70 26 q 6 9, 0 18" />
    </g>
  </svg>
);

export default TublyLogo;

